import './session_charts_view.js.coffee';# Added by Script 
Namespace 'Common.Sessions'

class Common.Sessions.SharedSessionChartsView extends Common.Sessions.SessionChartsView

  initialize: ({session, chartListItemCollectionViewFactory, sharedSession, isReadOnly, isResponsive}) ->
    @sharedSession = sharedSession
    @listenTo(@sharedSession, 'session:execution', @onSuccess)
    super({session, chartListItemCollectionViewFactory, isReadOnly, isResponsive})

  executeSession: =>
    @sharedSession.execute()

  onSuccess: (response) =>
    @session.widgets = new Common.Dashboard.WidgetCollection(response.widgets)
    @sessionExecutionResult = response.widgets_execution_result
    @renderCharts()
    @chartContainer.masonry('reloadItems')
